module.exports = __webpack_public_path__ + "img/btn_start2.4a6cf29a.png";